export function AccountIsMovedToCanada() {
	return <p>
		Your account has been moved to the Canadian environment. You can access login <a href='https://app.ca.esgisoftware.com/login'>here</a>.
		Thank you.
	</p>;
}